module.exports = __webpack_public_path__ + "img/Download.f7f237eb.svg";